import { render, staticRenderFns } from "./RfidDevicePanel.vue?vue&type=template&id=15d768be&scoped=true&"
import script from "./RfidDevicePanel.vue?vue&type=script&lang=js&"
export * from "./RfidDevicePanel.vue?vue&type=script&lang=js&"
import style0 from "./RfidDevicePanel.vue?vue&type=style&index=0&id=15d768be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d768be",
  null
  
)

export default component.exports